export const VIDEO_MORE_FROM_BASE_SECTION_UPDATE =
    "video_more_from_base_section_update";
export const VIDEO_MORE_FROM_BASE_SECTION_ERROR =
    "video_more_from_base_section_error";
export const VIDEO_MORE_FROM_BASE_SECTION_NULL =
    "video_more_from_base_section_null";
